import HelpLink from 'App/HelpLink';
import {
  ErrorScreen,
  HeaderContent,
  IonPageStratus,
  RenderByStatus,
} from 'commons/components';
import useTranslationOnline from 'domains/Online/useTranslationOnline';
import { InfoMessageForm } from './components';
import { useGetInfoMessageQuery } from './infoMessageApi';

export function InfoMessagePage() {
  const t = useTranslationOnline('infoMessage');
  const { isError, isLoading, refetch } = useGetInfoMessageQuery();

  return (
    <IonPageStratus
      width="small"
      headerContent={<HeaderContent title={t('title')} subtitle={t('text')} />}
    >
      <RenderByStatus
        isLoading={isLoading}
        isError={isError}
        success={<InfoMessageForm />}
        loading={<InfoMessageForm.Skeleton />}
        error={<ErrorScreen onRetry={refetch} />}
      />
      <HelpLink
        title={t('helpLink.title')}
        linkURL={t('helpLink.link')}
        currentViewTracking=""
        previousValue=""
        icon="both"
      />
    </IonPageStratus>
  );
}
